var path = 'services/info-toast.tpl.html';
var html = " <md-toast class=tk-info-toast> <div class=md-toast-content> <div class=md-toast-text ng-bind-html=vm.message></div> <md-button class=\"md-action md-highlight md-accent\" ng-click=vm.closeToast()> {{ 'action.close' | translate }} </md-button> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/info-toast.tpl.html
// module id = 1081
// module chunks = 1